import { render, staticRenderFns } from "./jumpLogin.vue?vue&type=template&id=2503a276&scoped=true&"
import script from "./jumpLogin.vue?vue&type=script&lang=js&"
export * from "./jumpLogin.vue?vue&type=script&lang=js&"
import style0 from "./jumpLogin.vue?vue&type=style&index=0&id=2503a276&scoped=true&lang=css&"
import style1 from "./jumpLogin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503a276",
  null
  
)

export default component.exports